import React from 'react';

const CriticalWarningIcon = (props) => {
  return (
    <svg
      // dataName='Layer 2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 50.76 40'
      className={props.className || null}
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.width ? `${props.width}px` : ''
      }}
    >
      <g
        // dataName='Layer 1'
      >
        <path d='M23.23 16.17h4.48v9.76h-4.48z'/>
        <path
          d='M50.76 40 25.38 0 0 40h50.76Zm-23.07-7.04h-4.61v-4.71h4.61v4.71Zm-4.61-7.06h4.61v-9.41h-4.61v9.41Z'
          style={{
            fill: '#ff0',
            fillRule: 'evenodd'
          }}
        />
        <path d='M23.12 28.14h4.48v4.77h-4.48z'/>
      </g>
    </svg>
  );
};

export default CriticalWarningIcon;
